import Image from 'next/image';
import Link from 'next/link';
import { Trans, useTranslation } from 'next-i18next';

type FooterVariant = 'primary' | 'minimal';

interface FooterProps {
  variant?: FooterVariant;
  text?: string;
}

function Footer({ variant = 'minimal', text }: FooterProps) {
  const { t } = useTranslation('components/trial/default-custom-trial');
  if (variant === 'primary') {
    return (
      <footer className='flex max-h-32 w-full items-center justify-center bg-[#0B0E12]'>
        <div className='flex w-full max-w-[1400px] flex-col justify-start gap-6 p-5 mobile:flex-row mobile:items-center lg:py-10'>
          <Link href='/' className='w-[180px] flex-col items-center justify-start gap-2.5 transition-opacity hover:opacity-80'>
            <Image width={180} height={40} src='/assets/images/novo-logo-verde-branco.png' alt='NoPing Logo' />
          </Link>
          <p className='text-sm font-bold text-[#616C7B]'>
            <Trans i18nKey={t('footer')} values={{ year: new Date().getFullYear() }} />
          </p>
        </div>
      </footer>
    );
  }

  return (
    <footer className='mx-auto flex w-full flex-col items-center justify-center gap-10 px-5 py-4 mobile:py-10'>
      <div className='flex flex-wrap items-center justify-center gap-5 tablet:gap-10'>
        <Image src='/assets/images/trial/new/logo-np.webp' alt='Logo NoPing' width={150} height={35} />
        <p className='text-center text-2xl font-normal leading-10 text-white'>{text}</p>
      </div>
    </footer>
  );
}

export { Footer };
export type { FooterProps, FooterVariant };
